import { Component } from '@angular/core';
import { NavParams, ViewController, PopoverController, Events, NavController } from 'ionic-angular';
import { AppState } from '../../config/state';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';

/**
 * Generated class for the CoBulkAddAttendancePopoverComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-bulk-add-attendance-popover',
  templateUrl: 'co-bulk-add-attendance-popover.html'
})
export class CoBulkAddAttendancePopoverComponent {
  ages: any;
  event: any;
  constructor(public viewCtrl: ViewController, public popoverCtrl: PopoverController, public navParams: NavParams, public state: AppState, private events: Events, private timeout: TimeoutFunctionsProvider, public navCtrl: NavController) {
    this.events.subscribe('timeoutCalled', () => this.timeout.doLogoutFunctions(this));

    if (this.navParams.data && this.navParams.data.hasOwnProperty('ages')){
      this.ages = this.navParams.get('ages');
      // console.log(this.ages);
      this.ages.map(age =>{
        age.adding = "";
        return age;
      });
    }
    if (this.navParams.data && this.navParams.data.hasOwnProperty('event')){
      this.event = this.navParams.get('event');

      this.ages.map(age => {
        if (this.event.attendanceGrouped) {
          // console.log(this.event.attendanceGrouped, this.ages);
          let grp = this.event.attendanceGrouped.find(grp => grp.name == age.nameSingular);
          if (!grp) {
            age.count = 0;
            return age;
          }
          age.count = grp.count;
          return age;
        } else {
          age.count = 0;
        }
      });
    }
  }
  addBulk(age, count){
    let current = this.ages.find(a=> a.id === age);
    if (!current.adding)current.adding = 0;
    current.adding += count;
    if (current.adding <= 0) current.adding = 0;
    // console.log(current.adding, count);
  }
  close(submit){
    if(submit) {
      this.ages.map(a => {
        if (!a.adding || a.adding == "") a.adding = 0;
        return a
      });
      this.viewCtrl.dismiss({ages: this.ages}, "", {animate: false});
    } else {
      this.viewCtrl.dismiss(false, "", {animate: false});
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/co-bulk-add-attendance-popover/co-bulk-add-attendance-popover.ts